import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import icon1 from "../../images/shape/trangle-shape.png";
import icon2 from "../../images/icon/m_01.svg";
import icon5 from "../../images/icon/m_04.svg";
import icon7 from "../../images/icon/m_06.svg";
import icon11 from "../../images/icon/m_10.svg";
import icon12 from "../../images/icon/m_11.svg";
import logo from "../../images/logo/Logo-certa.png";
import logoWhite from "../../images/logo/Logo-certa-white.png";
import clogo1 from "../../images/logo/client-logo.svg";
import clogo2 from "../../images/logo/client-logo2.svg";
import quote from "../../images/icon/quote.png";
import MobileMenu from "../MobileMenu/MobileMenu";

const Header = (props) => {
  const [mobailActive, setMobailState] = useState(false);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const [isSticky, setSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const SubmitHandler = (e) => {
    e.preventDefault();
  };

  return (
    <div
      id="xb-header-area"
      className="header-area header-style-two header-transparent"
    >
      <div className="header-top">
        <span>
          Aproveite nossa oferta do mês! Cloud VPS com infraestrutura nacional
          Services.
        </span>
        <span>
          <Link onClick={ClickHandler} to="/pricing">
            Saiba mais
          </Link>
          <i className="far fa-angle-right"></i>
        </span>
        <div className="header-shape">
          <div className="shape shape--one">
            <img src={icon1} alt="" />
          </div>
          <div className="shape shape--two">
            <img src={icon1} alt="" />
          </div>
        </div>
      </div>
      <div
        className={`xb-header stricky  ${
          isSticky ? "stricked-menu stricky-fixed" : ""
        }`}
      >
        <div className="container">
          <div className="header__wrap ul_li_between d-flex align-items-center">
            <div className="header-logo">
              <Link onClick={ClickHandler} to="/">
                <img
                  src={isSticky ? logo : logoWhite}
                  alt="Somar Cloud Logo"
                  style={{
                    transition: "opacity 0.3s ease-in-out",
                    maxHeight: "40px",
                    width: "auto",
                  }}
                />
              </Link>
            </div>
            <div className="main-menu__wrap ul_li navbar navbar-expand-xl flex-grow-1 justify-content-center">
              <nav className="main-menu collapse navbar-collapse">
                <ul>
                  <li className="menu-item-has-children">
                    <Link onClick={ClickHandler} to="/">
                      <span>Home</span>
                    </Link>
                  </li>
                  <li className="menu-item-has-children megamenu">
                    <Link onClick={ClickHandler} to="/">
                      <span>Empresa</span>
                    </Link>
                    <ul className="submenu">
                      <li>
                        <div className="mega_menu_wrapper">
                          <div className="container">
                            <div className="mega_menu_wrapper_inner">
                              <div className="row">
                                <div className="col-xl-9">
                                  <div className="megamenu_pages_wrapper mb-5">
                                    <div className="row g-10">
                                      <div className="col-xl-4 col-md-4">
                                        <Link
                                          onClick={ClickHandler}
                                          className="iconbox_block_2"
                                          to="/about"
                                        >
                                          <span className="icon_title_wrap">
                                            <small className="iconbox_icon">
                                              <img src={icon2} alt="" />
                                            </small>
                                            <small className="iconbox_title">
                                              Sobre Nós
                                            </small>
                                          </span>
                                          <span className="description mb-0">
                                            Referência em Cloud Services
                                          </span>
                                        </Link>
                                      </div>
                                      <div className="col-xl-4 col-md-4">
                                        <Link
                                          onClick={ClickHandler}
                                          className="iconbox_block_2"
                                          to="/service"
                                        >
                                          <span className="icon_title_wrap">
                                            <small className="iconbox_icon">
                                              <img src={icon5} alt="" />
                                            </small>
                                            <small className="iconbox_title">
                                              Soluções
                                            </small>
                                          </span>
                                          <span className="description mb-0">
                                            Potencialize seus resultados
                                          </span>
                                        </Link>
                                      </div>
                                      {/* <div className="col-xl-4 col-md-4">
                                        <Link
                                          onClick={ClickHandler}
                                          className="iconbox_block_2"
                                          to="/projects"
                                        >
                                          <span className="icon_title_wrap">
                                            <small className="iconbox_icon">
                                              <img src={icon7} alt="" />
                                            </small>
                                            <small className="iconbox_title">
                                              Projetos Entregues
                                            </small>
                                          </span>
                                          <span className="description mb-0">
                                            Desenvolvendo soluções para diversos
                                            segmentos
                                          </span>
                                        </Link>
                                      </div> */}
                                      {/* <div className="col-xl-4 col-md-4">
                                        <Link
                                          onClick={ClickHandler}
                                          className="iconbox_block_2"
                                          to="/career"
                                        >
                                          <span className="icon_title_wrap">
                                            <small className="iconbox_icon">
                                              <img src={icon8} alt="" />
                                            </small>
                                            <small className="iconbox_title">
                                              Trabalhe Conosco
                                            </small>
                                          </span>
                                          <span className="description mb-0">
                                            Lore Ipsum{" "}
                                          </span>
                                        </Link>
                                      </div> */}
                                      <div className="col-xl-4 col-md-4">
                                        <Link
                                          onClick={ClickHandler}
                                          className="iconbox_block_2"
                                          to="/terms-conditions"
                                        >
                                          <span className="icon_title_wrap">
                                            <small className="iconbox_icon">
                                              <img src={icon11} alt="" />
                                            </small>
                                            <small className="iconbox_title">
                                              Termos & Condições
                                            </small>
                                          </span>
                                          <span className="description mb-0">
                                            Seus Direitos e Resposabilidades.
                                          </span>
                                        </Link>
                                      </div>
                                      <div className="col-xl-4 col-md-4">
                                        <Link
                                          onClick={ClickHandler}
                                          className="iconbox_block_2"
                                          to="/privacy-policy"
                                        >
                                          <span className="icon_title_wrap">
                                            <small className="iconbox_icon">
                                              <img src={icon12} alt="" />
                                            </small>
                                            <small className="iconbox_title">
                                              Política de Privacidade
                                            </small>
                                          </span>
                                          <span className="description mb-0">
                                            Seus dados seguros.
                                          </span>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                  {/* <ul className="btns_group p-0 unordered_list justify-content-start">
                                    <li>
                                      <Link
                                        onClick={ClickHandler}
                                        to="/contact"
                                        className="thm-btn thm-btn--aso megamenu-btn thm-btn--header-blue"
                                      >
                                        Falar com um especialista
                                      </Link>
                                    </li>
                                    <li>
                                      <div className="review_short_info_2">
                                        <div className="review_admin_logo">
                                          <img src={clogo1} alt="" />
                                        </div>
                                        <div className="review_info_content">
                                          <ul className="rating_block unordered_list">
                                            <li>
                                              <i className="fas fa-star"></i>
                                            </li>
                                            <li>
                                              <i className="fas fa-star"></i>
                                            </li>
                                            <li>
                                              <i className="fas fa-star"></i>
                                            </li>
                                            <li>
                                              <i className="fas fa-star"></i>
                                            </li>
                                            <li>
                                              <i className="fas fa-star"></i>
                                            </li>
                                          </ul>
                                          <div className="review_counter">
                                            <b>200+</b> Avaliações
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="review_short_info_2">
                                        <div className="review_admin_logo">
                                          <img src={clogo2} alt="" />
                                        </div>
                                        <div className="review_info_content">
                                          <ul className="rating_block unordered_list">
                                            <li>
                                              <i className="fas fa-star"></i>
                                            </li>
                                            <li>
                                              <i className="fas fa-star"></i>
                                            </li>
                                            <li>
                                              <i className="fas fa-star"></i>
                                            </li>
                                            <li>
                                              <i className="fas fa-star"></i>
                                            </li>
                                            <li>
                                              <i className="fas fa-star"></i>
                                            </li>
                                          </ul>
                                          <div className="review_counter">
                                            <b>200+</b> Avaliações
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  </ul> */}
                                </div>
                                <div className="col-xl-3">
                                  <div className="autpr_box">
                                    <div className="site_author">
                                      <div className="author_box">
                                        {/* <div className="author_image bg-light">
                                                                                    <img src={avatar} alt="" />
                                                                                </div> */}
                                        <div className="author_box_content">
                                          <h2 className="author_name text-white">
                                            Reduza custos e melhore a
                                            performance da sua operação.
                                          </h2>
                                          <span className="author_designation text-white">
                                            Servidores ERP com alta performance.
                                          </span>
                                        </div>
                                      </div>
                                      <p className="mb-0 text-white"> </p>
                                      <Link
                                        onClick={ClickHandler}
                                        to="/contact"
                                        className="thm-btn thm-btn--aso megamenu-btn thm-btn--header-blue"
                                      >
                                        Quero Conhecer!
                                      </Link>
                                      <div className="author_box_quote">
                                        <img src={quote} alt="" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                  <li className="menu-item-has-children megamenu">
                    <Link onClick={ClickHandler} to="/service">
                      <span>Soluções</span>
                    </Link>
                    <ul className="submenu">
                      <li>
                        <div className="mega_menu_wrapper">
                          <div className="container">
                            <div className="mega_menu_wrapper_inner megamenu_widget_wrapper">
                              <div className="row justify-content-lg-between">
                                <div className="col-xl-8">
                                  <div className="megamenu_widget_inner">
                                    <div className="row">
                                      <div className="col-xl-6">
                                        <div className="megamenu_widget">
                                          <ul className="icon_list unordered_list_block">
                                            <li>
                                              <span className="icon_list_text fs-3 text-primary fw-bold">
                                                Nuvem:
                                              </span>
                                            </li>
                                            <li>
                                              <Link
                                                onClick={ClickHandler}
                                                to="/cloud-vps"
                                              >
                                                <span className="icon_list_text">
                                                  Cloud VPS
                                                </span>
                                              </Link>
                                            </li>
                                            <li>
                                              <Link
                                                onClick={ClickHandler}
                                                to="/cloud-server"
                                              >
                                                <span className="icon_list_text">
                                                  Cloud Server
                                                </span>
                                              </Link>
                                            </li>
                                            <li>
                                              <Link
                                                onClick={ClickHandler}
                                                to="/data-center-virtual"
                                              >
                                                <span className="icon_list_text">
                                                  Data Center Virtual
                                                </span>
                                              </Link>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <div className="col-xl-6">
                                        <div className="megamenu_widget">
                                          <ul className="icon_list unordered_list_block">
                                            <li>
                                              <span className="icon_list_text fs-3 text-primary fw-bold">
                                                Outras Soluções:
                                              </span>
                                            </li>
                                            <li>
                                              <Link
                                                onClick={ClickHandler}
                                                to="/vdi-windows11"
                                              >
                                                <span className="icon_list_text">
                                                  VDI Windows 11
                                                </span>
                                              </Link>
                                            </li>
                                            <li>
                                              <Link
                                                onClick={ClickHandler}
                                                to="/disaster-recorvery"
                                              >
                                                <span className="icon_list_text">
                                                  Disaster Recorvery
                                                </span>
                                              </Link>
                                            </li>
                                            <li>
                                              <Link
                                                onClick={ClickHandler}
                                                to="/microsoft-exchange"
                                              >
                                                <span className="icon_list_text">
                                                  Microsoft Exchange
                                                </span>
                                              </Link>
                                            </li>
                                            <li>
                                              <Link
                                                onClick={ClickHandler}
                                                to="/firewall-comodato"
                                              >
                                                <span className="icon_list_text">
                                                  Firewall Comodato
                                                </span>
                                              </Link>
                                            </li>
                                            <li>
                                              <Link
                                                onClick={ClickHandler}
                                                to="/backup-cloud"
                                              >
                                                <span className="icon_list_text">
                                                  Backup Cloud
                                                </span>
                                              </Link>
                                            </li>
                                            <li>
                                              <Link
                                                onClick={ClickHandler}
                                                to="/desenvolvimento-web"
                                              >
                                                <span className="icon_list_text">
                                                  Desenvolvimento Web
                                                </span>
                                              </Link>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="social_area">
                                    <div className="social_inner ul_li">
                                      <h5>Nos acompanhe nas redes:</h5>
                                      <ul className="social_icons_block unordered_list">
                                        <li>
                                          <Link onClick={ClickHandler} to="/">
                                            <i className="fab fa-facebook-f"></i>
                                          </Link>
                                        </li>
                                        <li>
                                          <Link onClick={ClickHandler} to="/">
                                            <i className="fab fa-linkedin-in"></i>
                                          </Link>
                                        </li>
                                        <li>
                                          <Link onClick={ClickHandler} to="/">
                                            <i className="fab fa-youtube text-danger"></i>
                                          </Link>
                                        </li>
                                      </ul>
                                    </div>
                                    {/* <p className="career_link m-0">
                                      Gostaria de trabalhar conosco?{" "}
                                      <Link onClick={ClickHandler} to="/career">
                                        Estamos contratando
                                      </Link>
                                    </p> */}
                                  </div>
                                </div>
                                <div className="col-xl-4">
                                  <div className="autpr_box d-flex align-items-center justify-content-center h-100 m-auto">
                                    <div className="site_author text-left">
                                      <div className="author_box">
                                        <div className="author_box_content">
                                          <h2 className="author_name text-white">
                                            Reduza custos e melhore a
                                            performance da sua operação.
                                          </h2>
                                          <span className="author_designation text-white">
                                            Servidores ERP com alta performance.
                                          </span>
                                        </div>
                                      </div>
                                      <p className="mb-0 text-white"> </p>
                                      <Link
                                        onClick={ClickHandler}
                                        to="/contact"
                                        className="thm-btn thm-btn--aso megamenu-btn thm-btn--header-blue"
                                      >
                                        Quero Conhecer!
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                  {/* <li className="menu-item-has-children">
                    <Link onClick={ClickHandler} to="/projects">
                      <span>Projetos Entregues</span>
                    </Link>
                  </li> */}
                  {/* <li className="menu-item-has-children">
                    <Link onClick={ClickHandler} to="/blog">
                      <span>Blog</span>
                    </Link>
                  </li> */}
                  <li>
                    <Link onClick={ClickHandler} to="/contact">
                      <span>Contato</span>
                    </Link>
                  </li>
                </ul>
              </nav>
              <div className="xb-header-wrap">
                <div
                  className={`xb-header-menu ${mobailActive ? "active" : ""}`}
                >
                  <div className="xb-header-menu-scroll lenis lenis-smooth">
                    <div
                      className="xb-menu-close xb-hide-xl xb-close"
                      onClick={() => setMobailState(!mobailActive)}
                    ></div>
                    <div className="xb-logo-mobile xb-hide-xl">
                      <Link onClick={ClickHandler} to="/" rel="home">
                        <img src={logo} alt="" />
                      </Link>
                    </div>
                    <div className="xb-header-mobile-search xb-hide-xl">
                      <form role="search" onSubmit={SubmitHandler}>
                        <input
                          type="text"
                          placeholder="Search..."
                          name="s"
                          className="search-field"
                        />
                        <button className="search-submit" type="submit">
                          <i className="far fa-search"></i>
                        </button>
                      </form>
                    </div>
                    <nav className="xb-header-nav">
                      <MobileMenu />
                    </nav>
                  </div>
                </div>
                <div className="xb-header-menu-backdrop"></div>
              </div>
            </div>
            <div className="header-bar-mobile side-menu d-xl-none">
              <button
                className="xb-nav-mobile"
                onClick={() => setMobailState(!mobailActive)}
              >
                <i className="far fa-bars"></i>
              </button>
            </div>
            {/* <div className="header-contact d-none d-md-block ms-auto">
              <Link
                onClick={ClickHandler}
                to="/contact"
                className="thm-btn thm-btn--aso thm-btn--header-blue d-flex align-items-center"
              >
                Marque uma conversa
              </Link>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
